<template>
  <div class="page-wrapper">

    <b-modal id="crop_modal" :title="$t('message.profile_change_avatar_button')" class="theme-modal"
             @ok="handleImageCrop" :ok-title="$t('message.profile_update_button')"
             :cancel-title="$t('message.cancel')" no-close-on-backdrop>
      <div v-if="base64 == ''">
        <b-form-file
            accept="image/*"
            size="lg"
            @input="parseFile"
            v-model="file1"
            :state="Boolean(file1)"
            :placeholder="$t('message.profile_select_file')"
            :drop-placeholder="$t('message.profile_drop_zone')"
        ></b-form-file>
      </div>
      <div v-if="base64 != ''">
        <cropper
            ref="cropper"
            class="cropper"
            :src="base64"

            :stencil-size="{
              width: 150,
              height: 150
            }"
            stencil-component="circle-stencil"
            image-restriction="stencil"
        />
      </div>
    </b-modal>

    <b-modal id="password_modal" :title="$t('message.profile_change_password_button')" class="theme-modal"
             @ok="handlePasswordChange"
             :ok-title="$t('message.profile_change_password_button')"
             :cancel-title="$t('message.cancel')"
             no-close-on-backdrop>

      <div class="error-red text-center" v-if="error.not">{{ $t('message.profile_error_same_password') }}</div>

      <div>
        <label class="col-form-label">{{ $t('message.profile_new_password') }}
          <b-button id="html-tooltip-top-1"
                    style="border: none !important;background: none !important;padding:0px;color: black"><i
              class="fa fa-question-circle"></i></b-button>
          <b-tooltip target="html-tooltip-top-1" triggers="hover" placement="top">
            {{ $t('message.register_password_tooltip') }}
          </b-tooltip>
        </label>
        <input
            v-model.trim="pass.newPass"
            class="form-control"
            type="password"
            name="pass_old"
            required=""
        />
        <div class="error-red " v-if="error.new">{{ $t('message.profile_error_password') }}</div>
      </div>
      <div>
        <label class="col-form-label">{{ $t('message.profile_new_password_repeat') }}
          <b-button id="html-tooltip-top-2"
                    style="border: none !important;background: none !important;padding:0px;color: black">
            <i class="fa fa-question-circle"></i></b-button>
          <b-tooltip target="html-tooltip-top-2" triggers="hover" placement="top">
            {{ $t('message.register_password_tooltip') }}
          </b-tooltip>
        </label>
        <input
            v-model.trim="pass.newPassRepeat"
            class="form-control"
            type="password"
            name="pass_old"
            required=""
        />
        <div class="error-red" v-if="error.repeat">{{ $t('message.profile_error_repeat_password') }}</div>
      </div>
    </b-modal>


    <div class="p-0 m-auto" v-if="editedUser">

      <div class="row">

        <div class="col-12" style="margin: 0 auto">
          <div class="edit-profile container container-md" style="margin: 0 auto">
            <div class="card ">

              <div v-if="loggedUser && loggedUser.name == ''">
                <div class="container">
                  <div class="alert alert-danger" style="overflow: auto;display: flex;align-items: center" role="alert">
                    {{ $t('message.no_name') }}
                  </div>
                </div>
              </div>

              <div class="card-header">

                <div class="row">
                  <div class="col-12 col-lg-6"><h4 class="card-title mb-0" v-if="editedUser && editedUser.image">
                    <img class="img-70 rounded-circle" alt="" :src="editedUser.image"> {{ $t("message.profile_title") }}
                  </h4></div>
                  <div class="col-12 col-lg-6 text-right">
                    <button class="btn btn-primary btn-sm" @click="changeAvatar">
                      {{ $t("message.profile_change_avatar_button") }}
                    </button>
                    <button class="btn btn-primary btn-sm" style="margin-left: 10px;" @click="changePassword">
                      {{ $t("message.profile_change_password_button") }}
                    </button>
                  </div>
                </div>

                <div class="card-options"><a class="card-options-collapse" href="#" data-toggle="card-collapse">
                  <i class="fe fe-chevron-up"></i></a>
                  <a class="card-options-remove" href="#" data-toggle="card-remove"><i class="fe fe-x"></i></a></div>
              </div>
              <div class="card-body">

                <div class="form-group">
                  <h6 class="form-label">{{ $t("message.profile_name") }}</h6>
                  <input class="form-control" v-model="editedUser.name">
                </div>

                <div class="form-group">
                  <h6 class="form-label">{{ $t("message.profile_info") }}</h6>
                  <textarea class="form-control" rows="5" v-model="editedUser.info"></textarea>
                </div>
                <div class="form-footer">
                  <button class="btn btn-primary btn-block" @click="updateProfile" :disabled="!editedUser || editedUser.name == ''">
                    {{ $t("message.profile_update_button") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {Cropper} from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'UserProfile',
  data() {
    return {
      editedUser: null,
      file1: null,
      base64: '',
      pass: {
        newPass: '',
        newPassRepeat: '',
      },
      error: {
        'new': false,
        'repeat': false,
        'not': false
      }
    }
  },
  components: {
    Cropper,
  },
  mounted() {
    this.editedUser = Object.assign({}, this.$store.getters['shared/getUser']);
  },
  methods: {
    updateProfile() {

      this.$store.dispatch('shared/updateUser', {
        'name': this.editedUser.name,
        'info': this.editedUser.info == null ? '' : this.editedUser.info,
      }).then(() => {
        this.$nextTick(() => {
          this.$router.go();
        })
      })

    },
    changePassword() {
      this.$bvModal.show('password_modal')
    },
    handlePasswordChange(bvModalEvent) {
      bvModalEvent.preventDefault()

      var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).*$/;

      this.error = {
        'new': false,
        'repeat': false,
        'not': false
      }

      let error = false

      if (!re.test(this.pass.newPass)) {
        this.error.new = true
        error = true
      }

      if (!re.test(this.pass.newPassRepeat)) {
        this.error.repeat = true
        error = true
      }

      if (!error) {

        if (this.pass.newPass != this.pass.newPassRepeat) {
          this.error.not = true
        } else {

          this.$store.dispatch('shared/updateUserPass', {
            'password': this.pass.newPass
          }).then(() => {
            this.$nextTick(() => {
              this.$router.go();
            })
          })


        }
      }
    },
    handleImageCrop(bvModalEvent) {

      bvModalEvent.preventDefault()

      if (this.base64 == '') return

      const {
        coordinates, image, visibleArea, canvas
      } = this.$refs.cropper.getResult();

      let resizedCanvas = document.createElement("canvas");
      let resizedContext = resizedCanvas.getContext("2d");

      resizedCanvas.height = "150";
      resizedCanvas.width = "150";

      resizedContext.drawImage(canvas, 0, 0, 150, 150);

      this.$store.dispatch('shared/updateUser', {
        'image': resizedCanvas.toDataURL()
      }).then(() => {
        this.$router.go();
      })

    },
    changeAvatar() {
      this.file1 = null
      this.base64 = ''
      this.$bvModal.show('crop_modal')
    },
    parseFile() {

      if (!this.file1) return

      const reader = new FileReader();

      reader.onload = (event) => {
        this.base64 = event.target.result
      }

      reader.readAsDataURL(this.file1);
    }
  },
  computed: {
    loggedUser() {
      return this.$store.getters['shared/getUser']
    },
    validation() {
      return this.pass.old.length > 4 && this.pass.old.length < 13
    }
  }
};
</script>

<style>

.edit-profile .card {
  margin-top: 80px;
  box-shadow: 2px -1px 25px -4px rgba(107, 107, 107, 0.75) !important;
  -webkit-box-shadow: 2px -1px 25px -4px rgba(107, 107, 107, 0.75) !important;
  -moz-box-shadow: 2px -1px 25px -4px rgba(107, 107, 107, 0.75) !important;
}

.crop_modal {
  user-select: none;
}

</style>
